import { SportMatchModel } from '@nf/types/odds';
import { OddsButton } from '@/components/widgets/odds-button';
import { useAtomValue } from 'jotai';
import { oddsPageAtom } from '@/atoms/odds-page';
import { useTranslations } from 'next-intl';
import { useAccountInfo } from '@/hooks/query/account';
import { BetTypeContentProps } from '../bet-type-content';
import { betTypeService } from '@/services/bettype.service';
import clsx from 'clsx';
import { useGetBetTypeSetting } from '@/hooks';

export const BetTypeCricketFancy = ({ matchModel, betTypeArray }: BetTypeContentProps) => {
	const getBetTypeSetting = useGetBetTypeSetting();

	const t = useTranslations('General');
	const { user } = useAccountInfo();
	const oddsData = useAtomValue(oddsPageAtom);

	const market = betTypeArray[0];
	const betTypeId = market.BetTypeId;
	const { betChoices, betTypesCategory, betChoiceDisplaySetting } = getBetTypeSetting(betTypeId, matchModel.GameID);

	const betChoiceDisplay = (betTeam: string) => {
		const teamName = betTypeService.getBetChoiceDisplayTeamName(betTypeId, betTeam, matchModel, t('Neutral_Team'), oddsData?.teamNameMap);
		return teamName ? teamName : betTypesCategory === 'fancyBackLay' ? t('lbl_draw') : null;
	}

	const getDisplayLine = (betTeam: string) => {
		const betLine = betChoiceDisplaySetting?.[betTeam]?.betLine;
		return betLine ? market[betLine] : null;
	}

	return (
		<div className={clsx('bettype__content', {
			'bettype__content--cricket-back-lay': betTypesCategory === 'fancyBackLay',
			'bettype__content--cricket-no-yes': betTypesCategory !== 'fancyBackLay',
		}
		)}
		>
			<div className="bettype__list">
				<div className="bettype__text"></div>
				{
					betTypesCategory === 'fancyBackLay' ? (
						<>
							<div className="bettype__title">{t('lbl_Crkt_Back')}</div>
							<div className="bettype__title">{t('lbl_Crkt_Lay')}</div>
						</>
					) : (
						<>
							<div className="bettype__title">{t('lbl_no')}</div>
							<div className="bettype__title">{t('lbl_yes')}</div>
						</>
					)
				}
			</div>
			{
				betChoices.map((choice, index) => {
					if (index % 2 === 1) {
						return null;
					}
					const betChoicesFilterArray = betChoices.filter((choiceItem) => choiceItem.betChoiceGroup === choice.betChoiceGroup);
					return (
						<div key={choice.betTeam} className="bettype__list">
							<div className="bettype__text">{betChoiceDisplay(choice.betTeam)}</div>
							{
								betChoicesFilterArray.map((choiceItem, choiceIndex) => {
									const line = getDisplayLine(choiceItem.betTeam);
									return (
										<OddsButton
											key={`${market.Line}_${choice.betTeam}_${choiceIndex}`}
											match={matchModel as SportMatchModel}
											market={market}
											selection={market.Selections[choiceItem.betTeam]}
											homeTeamName={''}
											awayTeamName={''}
											variant={betTypeService.getBetChoiceDisplaySettingBetTypeClassName(market.BetTypeId, choiceItem.betTeam)}
											betTeam={market.Selections[choiceItem.betTeam].SelId}
											originalPrice={market.Selections[choiceItem.betTeam].Price}
											sport={matchModel?.GameID}
											title={line?.toString()}
											type="OU"
											line={line?.toString()}
											oddsType={user?.OType}
											accountStatus={user?.ActStatus ?? 0}
										/>
									)
								})
							}
						</div>
					)
				})
			}
		</div>
	)
};
